import React, { Component } from "react";

import withStyles from "@material-ui/core/styles/withStyles";
import { createMuiTheme } from "@material-ui/core/styles";
import extendedTablesStyle from "assets/jss/material-dashboard-pro-react/views/extendedTablesStyle.jsx";
import DeleteModel from "components/Common/FevoModels/DeleteModel";
import OTPModel from "../RefundMangement";
import { connect } from "react-redux";
// import ScrollToTop from "react-scroll-up"
import ReactTable from "react-table";
import toastr from "toastr";
// import { hist } from "../../..";

import axios from "../../../config/axios";
import loaderIcon from "assets/img/loader.gif";
import FormControl from "@material-ui/core/FormControl";
import TextField from "@material-ui/core/TextField";
import GridContainer from "components/Grid/GridContainer.jsx";
import GridItem from "components/Grid/GridItem.jsx";
import Card from "components/Card/Card.jsx";
import CardBody from "components/Card/CardBody.jsx";
// import CancelIcon from "@material-ui/icons/Cancel";
import IconButton from "@material-ui/core/IconButton";
import green from "@material-ui/core/colors/green";
import Icon from "@material-ui/core/Icon";
import Tooltip from "@material-ui/core/Tooltip";
import ClearButton from "components/CustomButtons/Button";
import { Select, MenuItem, InputLabel } from "@material-ui/core";
import newaxios from "axios";
import { Button } from "@material-ui/core";
// import VisibilityIcon from "@material-ui/icons/Visibility";

import { getAllEvents$ } from "../../../redux/actions/event";
// import moment from "../../../../../../../Library/Caches/typescript/3.6/node_modules/moment/moment";
import moment from "moment";
// const formStyle = {
//   minWidth: "100%",
//   margin: "0 1.2rem 1.2rem 0"
// };

const formStyle = {
  minWidth: 300,
  margin: "0 1.2rem 1.2rem 0",
};

class ManageEvents extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showConfirmModal: false,
      userTobeChangedIndex: null,
      userTobeChange: null,
      eventData: [],
      loading_delay: false,
      limit: 500,
      offset: 0,
      showCancelModal: false,
      showOTPModel: false,
      eventTobeDeleted: "",
      search_event: "",
      status_category: "",
      ticket_type: "",
      statusList: [
        "SCHEDULED",
        "BOOKING_STARTED",
        "ONGOING",
        "COMPLETED",
        "ADMIN_CANCELLED",
        // "USER_CANCELLED"
      ],
      ticketTypeList: ["NORMAL", "EARLY_BIRD", "STUDENT", "GROUP", "COUPON"],
      otp: null,
      count: 0,
    };
  }

  async componentDidMount() {
    const body = { limit: this.state.limit, offset: this.state.offset };
    this.props.handleGetEventList();
    // console.log(eventAll,'eventAll')
    const redirect =
      this.props.history.location.state &&
      this.props.history.location.state.redirect
        ? true
        : false;
    // console.log(redirect,'redirect')
    const redirected_event_id =
      this.props.history.location.state &&
      this.props.history.location.state.redirected_event_id;

    if (redirect) {
      // console.log(this.props,'inside comp of index')
      this.props.handleGetEventList();

      let data;
      let event;
      let eventData;

      await axios.get(`events/all`).then((res) => {
        data = res && res.data && res.data.data;
        eventData =
          data && data.filter((event) => event.id == redirected_event_id);
        event = eventData && eventData[0];
        // this.props.location.state.event = data;
        // console.log(event,eventData,'event in redirect if')
        // console.log(data[0],'data at line 91')
      });
      if (data && data.length > 0) {
        // console.log('inside data.length line 95')
        this.setState({ eventData: this.props.eventListData.data });
      } else {
        this.setState({ eventData: [] });
      }

      // const event  = this.props.history.location.state && this.props.history.location.state.event
      // console.log(event,redirected_event_id,redirect,'event at line 102')
      // this.props.history.push("/admin/manageevents/eventdetail", {
      //   event
      // });
      // this.editEventFunc(eventData,redirect)
      this.props.history.push("/admin/manageevents/eventdetail", {
        event,
        redirect,
      });
    }
  }

  componentDidUpdate(prevProps) {
    if (this.props.eventListData !== prevProps.eventListData) {
      if (this.props.eventListData.data.length > 0) {
        this.setState({ eventData: this.props.eventListData.data });
      } else {
        this.setState({ eventData: [] });
      }
    }
  }

  editEventFunc = (event) => {
    // console.log(event,'inside editEventFunc')
    this.props.history.push("/admin/manageevents/eventdetail", {
      event,
    });
    // localStorage.setItem("eventId", event.id);
  };

  reset = () => {
    this.setState({
      status_category: "",
      ticket_type: "",
      search_event: "",
      eventData: this.props.eventListData.data,
    });
  };

  pageChange = () => {
    // window.location.reload();
    let node = document.getElementById("event_main_page");
    if (node) {
      node.scrollTop = 0;
    }
  };
  getUserTableColumn = () => {
    const { classes } = this.props;
    const theme = createMuiTheme({
      palette: {
        primary: green,
      },
    });
    let column = [
      {
        Header: "Event ID",
        accessor: "event_alias_id",
      },
      {
        // width : 170,
        Header: "Event Name",
        accessor: "name",
      },
      {
        Header: "Speaker",
        accessor: "speaker",
        Cell: (props) => {
          return (
            props.original &&
            props.original.event_speaker &&
            props.original.event_speaker.length > 0 &&
            Array.prototype.map
              .call(props.original.event_speaker, function(item) {
                let name = item.speaker ? item.speaker.name : null;
                return name;
              })
              .join(", ")
          );
        },
      },
      {
        Header: "Tags",
        accessor: "tags",
        Cell: (props) => {
          return (
            props.original &&
            props.original.event_category &&
            props.original.event_category.length > 0 &&
            Array.prototype.map
              .call(props.original.event_category, function(item) {
                return item.name;
              })
              .join(", ")
          );
        },
      },
      {
        // width : 150,
        Header: "Start Date",
        accessor: "start_date",
        Cell: (props) => {
          return (
            props.original &&
            props.original.start_date &&
            moment(props.original.start_date).format("DD MMM YYYY, h:mm a")
          );
        },
      },
      {
        // width : 150,
        Header: "End Date",
        accessor: "end_date",
        Cell: (props) => {
          return (
            props.original &&
            props.original.end_date &&
            moment(props.original.end_date).format("DD MMM YYYY, h:mm:ss a")
          );
        },
      },
      {
        // width : 150,
        Header: "Event Type",
        accessor: "event_type",
      },

      {
        Header: "Status",
        // accessor: "status"
        Cell: (props) => {
          return (
            props.original &&
            props.original.status &&
            props.original.status.replace("_", " ")
          );
        },
      },
      {
        Header: "Report",
        accessor: "reports",
        sortable: false,
        filterable: false,
        headerStyle: { textAlign: "center" },
        Cell: (event) => {
          return (
            <div className="">
              <Tooltip title="Download">
                <IconButton
                  color="primary"
                  className={classes.button}
                  onClick={(e) => {
                    e.stopPropagation();
                    console.log(
                      `${process.env.REACT_APP_BASE_URL}booking/eventReportCSV?event_id=${event.original.id}`,
                      "process.env.REACT_APP_BASE_URL"
                    );
                    window.open(
                      `${process.env.REACT_APP_BASE_URL}booking/eventReportCSV?event_id=${event.original.id}`
                    );
                  }}
                >
                  <Icon>get_app</Icon>
                </IconButton>
              </Tooltip>
            </div>
          );
        },
      },
      {
        Header: "Actions",
        accessor: "actions",
        sortable: false,
        minWidth: 400,
        filterable: false,
        headerStyle: { textAlign: "left" },
        Cell: (event) => {
          return (
            <div className="actions-center" style={{ justifyContent: "left" }}>
              <Button
                color="primary"
                variant="contained"
                size="small"
                style={{ minWidth: "55px", fontSize: "12px", marginLeft: "6%" }}
                onClick={(e) => {
                  e.stopPropagation();
                  this.props.history.push("/admin/manageevents/eventdetail", {
                    event: event.original,
                  });
                }}
              >
                View
              </Button>

              {//  ( event.original && event.original.is_cancelled === true )
              //     &&
              // event.original.is_cancelled &&
              event.original.status === "SCHEDULED" ||
              event.original.status === "BOOKING_STARTED" ? (
                <Button
                  color="secondary"
                  variant="contained"
                  size="small"
                  style={{
                    minWidth: "55px",
                    fontSize: "12px",
                    marginLeft: "6%",
                  }}
                  onClick={(e) => {
                    e.stopPropagation();
                    this.setState({
                      showCancelModal: true,
                      eventTobeDeleted: event.original.id,
                    });
                  }}
                >
                  Cancel
                </Button>
              ) : null}
              {(event.original &&
                event.original.status === "BOOKING_STARTED") ||
              event.original.status === "SCHEDULED" ||
              event.original.status === "ONGOING" ? (
                <Button
                  color="primary"
                  variant="contained"
                  size="small"
                  style={{
                    minWidth: "55px",
                    fontSize: "12px",
                    marginLeft: "6%",
                  }}
                  onClick={(e) => {
                    e.stopPropagation();
                    this.props.history.push("/admin/manageevents/editevent", {
                      action: "edit",
                      event: event.original,
                    });
                  }}
                >
                  Edit
                </Button>
              ) : null}
            </div>
          );
        },
      },
    ];
    return column;
  };

  cancelEvent = (eventInfo) => {
    debugger;
  };

  getVal = (otp) => {
    if (otp && otp.length === 4) {
      this.setState({ ...this.state, otp });
    }
  };

  render() {
    const {
      eventData,
      showCancelModal,
      showOTPModel,
      search_event,
      statusList,
      status_category,
      ticket_type,
      eventTobeDeleted,
      otp,
      timerCount,
      ticketTypeList,
    } = this.state;
    const { eventListData, classes } = this.props;
    const { loading, data } = eventListData;
    const { loading_delay } = this.state;
    return (
      <div>
        {loading || loading_delay ? (
          <div className="loader_icon">
            <img src={loaderIcon} />
          </div>
        ) : (
          <div>
            <GridContainer>
              <GridItem xs={12}>
                <Card>
                  <CardBody className="table_space main_event_time">
                    <FormControl
                      className={classes.formControl}
                      style={formStyle}
                    >
                      <TextField
                        id="standard-search"
                        label="Search Event by name"
                        name="search_event"
                        type="search"
                        fullWidth
                        value={search_event}
                        onChange={(event) => {
                          const { value } = event.target;
                          this.setState(
                            {
                              eventData: data,
                            },
                            () => {
                              const newEventData = this.state.eventData.filter(
                                (item) =>
                                  item.name
                                    .toLowerCase()
                                    .includes(value.toLowerCase())
                              );
                              this.setState({
                                eventData: newEventData,
                                search_event: value.toLowerCase(),
                              });
                            }
                          );
                        }}
                        margin="normal"
                      />
                    </FormControl>

                    <FormControl
                      className={classes.formControl}
                      style={formStyle}
                    >
                      <InputLabel id="demo-simple-select-label">
                        Select Status
                      </InputLabel>
                      <Select
                        autoWidth
                        labelid="demo-simple-select-label"
                        id="demo-simple-select"
                        value={status_category ? status_category : ""}
                        onChange={(event) => {
                          let { value } = event.target;

                          this.setState(
                            {
                              eventData: data,
                              status_category: value,
                            },
                            () => {
                              const newEventData = this.state.eventData.filter(
                                (item) =>
                                  item.status
                                    .toLowerCase()
                                    .replace("_", " ")
                                    .includes(value.toLowerCase())
                              );
                              this.setState({
                                eventData: newEventData,
                              });
                            }
                          );
                        }}
                      >
                        <MenuItem value="" disabled>
                          Select Status
                        </MenuItem>
                        {statusList.map((status, index) => {
                          return (
                            <MenuItem
                              key={index}
                              value={status.replace("_", " ")}
                            >
                              {status.replace("_", " ")}
                            </MenuItem>
                          );
                        })}
                      </Select>
                    </FormControl>

                    {/* <FormControl
                      className={classes.formControl}
                      style={formStyle}
                    >
                      <InputLabel id="demo-simple-select-label">
                        Select Ticket Type
                      </InputLabel>
                      <Select
                        autoWidth
                        labelid="demo-simple-select-label"
                        id="demo-simple-select"
                        value={ticket_type ? ticket_type : ""}
                        onChange={(event) => {
                          let { value } = event.target;

                          this.setState(
                            {
                              eventData: data,
                              ticket_type: value,
                            },
                            () => {
                              const newEventData = this.state.eventData.filter(
                                (item) =>
                                  item.status
                                    .toLowerCase()
                                    .replace("_", " ")
                                    .includes(value.toLowerCase())
                              );
                              this.setState({
                                eventData: newEventData,
                              });
                            }
                          );
                        }}
                      >
                        <MenuItem value="" disabled>
                          Select Ticket Type
                        </MenuItem>
                        {ticketTypeList.map((status, index) => {
                          return (
                            <MenuItem
                              key={index}
                              value={status.replace("_", " ")}
                            >
                              {status.replace("_", " ")}
                            </MenuItem>
                          );
                        })}
                      </Select>
                    </FormControl> */}

                    <FormControl>
                      <ClearButton
                        onClick={() => {
                          this.reset();
                        }}
                        variant="contained"
                        color="iseas"
                      >
                        Clear Filter
                      </ClearButton>
                    </FormControl>

                    <ReactTable
                      data={eventData || []}
                      loading={loading}
                      columns={this.getUserTableColumn()}
                      defaultPageSize={25}
                      pageSizeOptions={[25, 50, 100]}
                      showPaginationBottom={true}
                      minRows={0}
                      noDataText="No events found!"
                      onPageChange={this.pageChange}
                      onPageSizeChange={this.pageChange}
                      getTrProps={(state, rowInfo, column, instance) => {
                        return {
                          onClick: (e, handleOriginal) => {
                            if (rowInfo) {
                              // console.log(rowInfo,'rowInfo')
                              this.editEventFunc(rowInfo.original);
                            }
                          },
                          style: {
                            cursor: "pointer",
                          },
                        };
                      }}
                      getTheadThProps={(state, rowInfo, column, instance) => {
                        return {
                          style: {
                            marginBottom: "13px",
                          },
                        };
                      }}
                    />
                  </CardBody>
                </Card>
              </GridItem>
            </GridContainer>
            {/* <ScrollToTop showUnder={160}>
                    <span>UPykhgyfiuuti</span>
                  </ScrollToTop> */}
            <OTPModel
              // CountTimer = {timerCount}
              showModel={showOTPModel}
              eventTobeDeleted={eventTobeDeleted}
              handleGetEventList={this.props.handleGetEventList}
              title={
                "Enter OTP Recieved by Admin for this Event Cancellation. This event will be cancelled permantently. Do you want to continue?"
              }
              onCancel={() => {
                this.setState({
                  showOTPModel: false,
                });
              }}
              getOtpVal={this.getVal}
              onOk={() => {
                const body = {
                  refund_otp: otp,
                  status: "ADMIN_CANCELLED",
                  cancellation_reason: "some reason",
                };
                axios
                  .patch(`events/${eventTobeDeleted}/status`, body)
                  .then((res) => {
                    if (res.status === 200 || res.status === 201) {
                      toastr.success("Event Cancelled Successfully!");
                      this.setState({
                        showCancelModal: false,
                        showOTPModel: false,
                      });
                      const body = {
                        limit: this.state.limit,
                        offset: this.state.offset,
                      };
                      this.props.handleGetEventList();
                    }
                  })
                  .catch((error) => {
                    if (error) {
                      toastr.error(
                        error.response &&
                          error.response.data &&
                          error.response.data.message
                      );
                    }

                    this.setState({
                      showCancelModal: false,
                      showOTPModel: false,
                    });
                  });
              }}
            />

            <DeleteModel
              showModel={showCancelModal}
              title={"Are you sure you want to cancel the event?"}
              onCancel={() => {
                this.setState({
                  showCancelModal: false,
                });
              }}
              onOk={() => {
                const { eventTobeDeleted } = this.state;
                this.setState({
                  showCancelModal: false,
                  loading_delay: true,
                });
                console.log("ok clicked");
                //  this.props.handleGetEventList();
                // console.log(eventTobeDeleted);

                newaxios
                  .patch(
                    `${process.env.REACT_APP_BASE_URL}events/${eventTobeDeleted}/refundOTP`,
                    {}
                  )
                  .then((res) => {
                    if (res.status === 200 || res.status === 201) {
                      toastr.success("OTP Sent Successfully!");
                      this.setState({
                        ...this.state,
                        loading_delay: false,
                      });
                      const body = {
                        limit: this.state.limit,
                        offset: this.state.offset,
                      };
                      this.props.handleGetEventList();
                      setTimeout(() => {
                        this.setState({
                          ...this.state,
                          showOTPModel: true,
                          // showCancelModal:false
                        });
                      }, 800);
                    }
                  })
                  .catch((error) => {
                    toastr.error(error.response.data.message);
                    this.setState({
                      showCancelModal: false,
                    });
                  });
              }}
            />
          </div>
        )}
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    eventListData: state.event,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    handleGetEventList: (body) => dispatch(getAllEvents$.trigger(body)),
  };
};

const ManageEventsListComponent = withStyles(extendedTablesStyle)(ManageEvents);
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ManageEventsListComponent);



// WEBPACK FOOTER //
// ./src/views/ISEAS/EventManagement/index.js